import styled from 'styled-components';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import spacing from '@decisiv/design-tokens/lib/spacing';
import rem from 'polished/lib/helpers/rem';

export const CenteredContainer = styled(Flex)`
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--if-surface-2-50);
`;

export const HelpInputMessage = styled(Flex)`
  margin-top: ${rem(spacing.base * 0.2)};
  color: var(--if-ink-2);
`;
